const services = [
  {
    icon: "ri-flashlight-line",
    title: "Emergency Passport",
    desc: "24–72 hour processing for life-or-death emergencies and urgent travel from Cedar Rapids.",
    cta: "Get Emergency Help",
  },
  {
    icon: "ri-refresh-line",
    title: "Passport Renewal",
    desc: "Fast renewal for adult passports issued within the last 15 years. Start online from Cedar Rapids.",
    cta: "Renew My Passport",
  },
  {
    icon: "ri-passport-line",
    title: "New Passport",
    desc: "First-time application guidance with step-by-step support for Cedar Rapids first-time applicants.",
    cta: "Apply for New Passport",
  },
  {
    icon: "ri-alert-line",
    title: "Lost or Stolen",
    desc: "Replace a lost or stolen passport quickly. DS-64 form guidance included for Cedar Rapids travelers.",
    cta: "Replace Lost Passport",
  },
  {
    icon: "ri-parent-line",
    title: "Child Passport",
    desc: "Passport services for minors under 16. Parental consent guidance for Cedar Rapids families.",
    cta: "Child Passport Help",
  },
  {
    icon: "ri-file-edit-line",
    title: "Name Change",
    desc: "Update your passport after marriage, divorce, or legal name change. Fast processing from Cedar Rapids.",
    cta: "Update Name",
  },
  {
    icon: "ri-bank-card-line",
    title: "Passport Card",
    desc: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
    cta: "Get Passport Card",
  },
  {
    icon: "ri-error-warning-line",
    title: "Damaged Passport",
    desc: "Replacement for water-damaged, torn, or mutilated passports no longer valid for travel.",
    cta: "Replace Damaged Passport",
  },
  {
    icon: "ri-file-copy-line",
    title: "Second Passport",
    desc: "Second valid U.S. passport for frequent international travelers who need overlapping visas.",
    cta: "Get Second Passport",
  },
];

export default function CedarRapidsServicesSection() {
  return (
    <section id="services" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Our Services</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Expedited Passport Services in Cedar Rapids
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Every passport service you need — available remotely for Cedar Rapids and eastern Iowa travelers. No office visit required.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all duration-200 flex flex-col">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-4">
                <i className={`${s.icon} text-[#1A365D] text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-base mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-5 flex-1">{s.desc}</p>
              <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm hover:text-[#F6C344] transition-colors whitespace-nowrap">
                {s.cta} <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}